import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

export default class FlexiblePromotionsRestService extends BaseRestService {

    getPromotion(promotion) {

        return super.getAllAsync(`flexible-promotions/?filter[type]=${promotion.type}&filter[source]=${promotion.source}&filter[purchase_type]=${promotion.purchaseType}&filter[product]=${promotion.product}&filter[runtime]=${promotion.runtime}&filter[devices]=${promotion.devices}`);

    }

    getPromotionById(promotionId) {

        return super.getAllAsync(`flexible-promotions/${promotionId}/`);

    }

    getPromotionByActivationCode(activationCode, runtime, product) {

        return super.getAllAsync(`flexible-promotions/?filter[activation_code]=${activationCode}&filter[type]=public&filter[source]=cw${runtime ? `&filter[runtime]=${runtime}` : ''}${product ? `&filter[product]=${product}` : ''}`);

    }

}

_serviceDependencies.push(FlexiblePromotionsRestService);

angular.module('rest.services')
    .service('FlexiblePromotionsRestService', _serviceDependencies);




// WEBPACK FOOTER //
// ./scripts/restServices/flexiblePromotionsRestService.js